import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import Header from '../Header';
import Dashboard from './Dashboard';
import TaskManager from './TaskManager';
import PomodoroTimer from './PomodoroTimer';
import SubjectTracker from './SubjectTracker';
import StreakTracker from './StreakTracker';
import Analytics from './Analytics';
import ResourceLibrary from './ResourceLibrary';
import Achievements from './Achievements';
import './StudyTools.css';
import { FaTachometerAlt, FaTasks, FaClock, FaBook, FaFire, FaChartBar, FaFolder, FaTrophy } from 'react-icons/fa';

const StudyTools = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const { currentUser } = useAuth();

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard />;
      case 'tasks':
        return <TaskManager />;
      case 'pomodoro':
        return <PomodoroTimer />;
      case 'subjects':
        return <SubjectTracker />;
      case 'streaks':
        return <StreakTracker />;
      case 'analytics':
        return <Analytics />;
      case 'resources':
        return <ResourceLibrary />;
      case 'achievements':
        return <Achievements />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <div className="study-tools-container">
      <Header />
      <div className="study-tools-content">
        <div className="study-tools-sidebar">
          <div className="user-welcome">
            <div className="user-avatar">
              {currentUser?.name?.charAt(0).toUpperCase()}
            </div>
            <h3>Welcome, {currentUser?.name?.split(' ')[0]}</h3>
          </div>
          
          <nav className="study-tools-nav">
            <button 
              className={`nav-item ${activeTab === 'dashboard' ? 'active' : ''}`}
              onClick={() => setActiveTab('dashboard')}
            >
              <FaTachometerAlt /> Dashboard
            </button>
            
            <button 
              className={`nav-item ${activeTab === 'tasks' ? 'active' : ''}`}
              onClick={() => setActiveTab('tasks')}
            >
              <FaTasks /> Tasks & Goals
            </button>
            
            <button 
              className={`nav-item ${activeTab === 'pomodoro' ? 'active' : ''}`}
              onClick={() => setActiveTab('pomodoro')}
            >
              <FaClock /> Pomodoro Timer
            </button>
            
            <button 
              className={`nav-item ${activeTab === 'subjects' ? 'active' : ''}`}
              onClick={() => setActiveTab('subjects')}
            >
              <FaBook /> Subject Tracker
            </button>
            
            <button 
              className={`nav-item ${activeTab === 'streaks' ? 'active' : ''}`}
              onClick={() => setActiveTab('streaks')}
            >
              <FaFire /> Streaks
            </button>
            
            <button 
              className={`nav-item ${activeTab === 'analytics' ? 'active' : ''}`}
              onClick={() => setActiveTab('analytics')}
            >
              <FaChartBar /> Analytics
            </button>
            
            <button 
              className={`nav-item ${activeTab === 'resources' ? 'active' : ''}`}
              onClick={() => setActiveTab('resources')}
            >
              <FaFolder /> Resources
            </button>
            
            <button 
              className={`nav-item ${activeTab === 'achievements' ? 'active' : ''}`}
              onClick={() => setActiveTab('achievements')}
            >
              <FaTrophy /> Achievements
            </button>
          </nav>
        </div>
        
        <div className="study-tools-main">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default StudyTools; 